import { App } from "@vue/runtime-core";
import LogRocket from "logrocket";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default (app: App): void => {
  if (process.env.NODE_ENV === "production") {
    LogRocket.init("x7zgni/mysyndic");
  }
};
